import { IRole, IUser } from "../../interfaces/user";
import { SET_ROLES, SET_USER_DETAILS } from "../types";


export const setRoles = (payload: IRole[]) => ({
    type: SET_ROLES,
    payload,
});

export const setUserDetails = (payload: IUser) => ({
    type: SET_USER_DETAILS,
    payload,
});


